import { config } from "/app.config"

export const accountPlanFeatures = (state) => {
  return state.accountPlanFeatures
}

export const allowedStationsCount = (state) => {
  return state.accountPlanFeatures?.allowedStationsCount
}

export const allowedPodcastsCount = (state) => {
  return state.accountPlanFeatures?.allowedPodcastsCount
}

export const allowedBotPodcastsCount = (state) => {
  return state.accountPlanFeatures?.allowedRecordingAiPodcastsCount
}

export const allowedTracksCount = (state, getters, rootState, rootGetters) => {
  const isPortalAdmin = rootGetters["Profile/isPortalAdmin"]

  if (isPortalAdmin) {
    return 10000
  }

  return state.accountPlanFeatures?.allowedTracksCount
}

export const allowedBitRateLimit = (state, getters, rootState, rootGetters) => {
  const isPortalAdmin = rootGetters["Profile/isPortalAdmin"]

  if (isPortalAdmin) {
    return 320000
  }

  return state.accountPlanFeatures?.allowedBitRateLimit
}

export const canCreateStation = (state, getters, rootState, rootGetters) => {
  const isPortalAdmin = rootGetters["Profile/isPortalAdmin"]

  if (isPortalAdmin) {
    return true
  }

  if (!getters.accountPlanFeatures) {
    return null
  }

  const masters = rootGetters["AccountStations/masters"]

  if (masters === null) {
    return null
  }

  return masters.length < getters.allowedStationsCount
}

export const canCreatePodcast = (state, getters, rootState, rootGetters) => {
  const isPortalAdmin = rootGetters["Profile/isPortalAdmin"]

  if (isPortalAdmin) {
    return true
  }

  if (!getters.accountPlanFeatures) {
    return null
  }

  const podcasts = rootGetters["Podcast/podcasts"]

  if (podcasts === null) {
    return null
  }

  return podcasts.length < getters.allowedPodcastsCount
}

export const canCreateBotPodcast = (state, getters, rootState, rootGetters) => {
  const isPortalAdmin = rootGetters["Profile/isPortalAdmin"]

  if (isPortalAdmin) {
    return true
  }

  // Brands without commerce have no plans to draw a quota from; the env toggle is the only gate.
  if (!config.hasSubscriptions) {
    return true
  }

  if (!getters.accountPlanFeatures) {
    return null
  }

  const botPodcastCount = rootGetters["Podcast/botPodcastCount"]

  if (botPodcastCount === null) {
    return null
  }

  return botPodcastCount < getters.allowedBotPodcastsCount
}
